/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import {
	GA4_EVENT_PURCHASE,
	PAGE_DATA_LAYER,
	PURCHASE,
} from '@/data/constants/gtm';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMIntertoysPurchasePayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';
import { pickBy } from 'lodash';
import { getGAIntertoysPurchaseData } from '../../data/GAIntertoysPurchaseData';

/**
 * Measure transaction details into the Data Layer using the purchase action.
 * @param data transformed input payload from purchase event (see data-type)
 */
 export const measure_GA4_IntertoysPurchase = async (data: Awaited<ReturnType<typeof getGAIntertoysPurchaseData>>) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const {
		products, id, revenue, tax, shipping, affiliation, checkoutBuyerEmail, coupon, settings
	} = data;
	// TODO Remove this before Go Live. 
	//console.debug(" measure_GA4_IntertoysPurchase data is ",data);
	const items = products.map(
		({
			name,
			id,
			price,
			quantity,
			dimension113,
			tradingTrackingId,
		}) => ({
			name,
			id,
			...pickBy(
				{
					price,
					dimension113,
					tradingTrackingId,
					quantity,
				},
				Boolean
			),
		})
	);
	const tagManagerArgsGA4 = {
		dataLayer: {
			event: GA4_EVENT_PURCHASE,
			eventModel: {
				transaction_id: id,
				...pickBy(
					{ currency: 'EUR', value: revenue, tax: tax, shipping: shipping, affiliation, checkoutBuyerEmail, coupon },
					Boolean
				),
				items,
				hclMarketplace: 'intertoys',
				count_purchase: 1,
			},
		},
		dataLayerName,
	};
	console.debug("GA4_IntertoysPurchase .. ",tagManagerArgsGA4);
	TagManager.dataLayer(tagManagerArgsGA4);
}; 

export const sendGTMIntertoysPurchaseEvent = async (payload: GTMIntertoysPurchasePayload) => {	
	const { settings } = payload;
	const { ga4, ua } = getGTMConfig(settings);

	if (ua || ga4) {
		const data = await getGAIntertoysPurchaseData(payload);

		if (ga4) {
			try {
				await measure_GA4_IntertoysPurchase(data);
			} catch (error) {
				logError(undefined, 'Purchase: sendGTMIntertoysPurchaseEvent: measure_GA4: error: %o', error);
			}
		}
	}
}